module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8011.e69ecc23.png";